import { ThreePlPartner } from '../entities/partner-entity';
import { PartnerRepository } from '../repositories/partner-repository';

interface ThreePlPartnerUsecase {
  CreatePartner(name: string, hook: string): Promise<ThreePlPartner>;
  EditPartner(id: string, name: string, hook: string): Promise<ThreePlPartner>;
  GetPartner(id: string): Promise<ThreePlPartner>;
  GetPartners(): Promise<ThreePlPartner[]>;
}

export class ThreePlPartnerUsecaseImpl implements ThreePlPartnerUsecase {
  threePlPartnerRepo: PartnerRepository;

  constructor(three_pl: PartnerRepository) {
    this.threePlPartnerRepo = three_pl;
  }

  CreatePartner(name: string, hook: string): Promise<ThreePlPartner> {
    return this.threePlPartnerRepo.CreatePartner(name, hook);
  }
  EditPartner(id: string, name: string, hook: string): Promise<ThreePlPartner> {
    return this.threePlPartnerRepo.EditPartner(id, name, hook);
  }
  GetPartner(id: string): Promise<ThreePlPartner> {
    return this.threePlPartnerRepo.GetPartner(id);
  }
  GetPartners(): Promise<ThreePlPartner[]> {
    return this.threePlPartnerRepo.GetPartners();
  }
}
